module.exports = __webpack_public_path__ + "static/1215073452.da746d69.jpg";